import { makeStyles } from '@mui/styles';
import { SvgIcon, Box, IconButton } from '@mui/material';
import {
  RiSearchLine, RiCloseFill, RiDeleteBin6Line, RiArrowLeftSLine, RiArrowRightSLine, RiMapPinLine,
  RiArrowDropUpLine, RiArrowDropDownLine, RiCalendarTodoLine, RiHeart3Line, RiHeart3Fill,
  RiTimeLine, RiGlobalLine, RiCloseCircleLine, RiSmartphoneLine, RiErrorWarningLine, RiRestartLine,
  RiAddCircleFill, RiAddCircleLine, RiIndeterminateCircleFill, RiIndeterminateCircleLine,
  RiEqualizerLine, RiMenu2Line, RiHome3Line, RiArrowRightLine, RiArrowLeftRightFill, RiSubtractFill,
  RiCheckboxCircleFill, RiCheckboxBlankCircleLine, RiCheckboxCircleLine,
  RiRestaurantLine, RiHotelBedLine, RiDownload2Line,
  RiFlag2Line, RiFlightTakeoffLine, RiMap2Line, RiAlarmWarningLine,
  RiSparkling2Line, RiSuitcase2Line, RiFileEditLine,
  RiThumbUpLine,
  RiArrowDownSLine, RiArrowUpSLine,
  RiExternalLinkLine,
  RiEditLine,
  RiFlashlightLine, RiFootprintLine, RiArmchairLine,
  RiDraggable, RiAddFill, RiCloseLine,
  RiResetLeftLine, RiCheckLine,
  RiInformationLine,
  RiCloseCircleFill
} from 'react-icons/ri';
import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai';
import { FcGoogle, } from 'react-icons/fc';
import { FaLine } from 'react-icons/fa';
import { FiThumbsUp } from 'react-icons/fi';
import { VscAccount } from 'react-icons/vsc';
import { IoShareSocialOutline } from 'react-icons/io5';
import { BsCreditCard } from 'react-icons/bs';
import { BiArrowToTop } from 'react-icons/bi';
import { TbCopy, TbExclamationCircle } from 'react-icons/tb';
import { IoIosAirplane } from 'react-icons/io';
import { TiStarOutline } from 'react-icons/ti';
import { GrScheduleNew } from 'react-icons/gr';
import { clsx } from 'clsx';


const useStyles = makeStyles((theme) => ({
  iconBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cursorGrab: {
    cursor: 'grab',
  },
  iconTaiwan: {
    width: 50,
    height: 50,
    overflow: 'hidden',
  },
  iconButton: {
    '&:hover': {
      background: `${theme.palette.icon.iconBtnHover} !important`,

      '& svg': {
        color: theme.palette.icon.iconHover,
      }
    },

    '& svg': {
      color: theme.palette.icon.iconMain,
    }
  }
}));


export {
  ICON_HOME, ICON_SEARCH, ICON_CLOSE, ICON_DELETE_DRAG, ICON_ARROW_LEFT, ICON_ARROW_RIGHT, ICON_MAP_PIN,
  ICON_ARROW_UP, ICON_ARROW_DOWN, ICON_CALENDAR, ICON_FAVORITE_FALSE, ICON_FAVORITE_TRUE,
  ICON_DAY, ICON_GLOBAL, ICON_CLOSE_CIRCLE, ICON_OK_CIRCLE, ICON_PHONE, ICON_NOTICE, ICON_RESTART,
  ICON_ADD, ICON_ADD_LINE, ICON_DEL, ICON_DEL_LINE,
  ICON_LOGO_GOOGLE, ICON_LOGO_LINE, ICON_PASSWORD_SHOW, ICON_PASSWORD_HIDE, ICON_OPTIONS,
  ICON_ACCOUNT, ICON_MENU, ICON_SHARE, ICON_CREDIT_CARD, ICON_TO_TOP,
  ICON_ARROW_ONE_WAY, ICON_ARROW_TWO_WAY, ICON_DASH, ICON_CHECKBOX_CIRCLE_TRUE, ICON_CHECKBOX_CIRCLE_FALSE,
  ICON_MEALS, ICON_HOTEL, ICON_COPY, ICON_FILESERVER_DOWNLOAD,
  ICON_TRAVE_INFO, ICON_FLIGHT_HOTEL, ICON_SCHEDULE, ICON_INFORMATION,
  ICON_AI_CREATE, ICON_SUITCASE, ICON_EDIT_FORM,
  ICON_SUCCESS,
  ICON_SLINE_ARROW_UP, ICON_SLINE_ARROW_DOWN,
  ICON_LINK,
  ICON_EDIT_LINE,
  ICON_FLASHLIGHT, ICON_FOOTPRINT, ICON_ARMCHAIR,
  ICON_DRAGGABLE, ICON_ADD_FILL, ICON_CLOSE_LINE,
  ICON_RESET_LEFT_LINE, ICON_CHECK_LINE,
  ICON_INFORMATION_LINE,
  ICON_CLOSE_RADIUS
}


/**
 * ICON
 * boxSize l:50 m:40 s:30
 * svgSize l:1em m:0.8em s:0.65em
 */
const ICON = ({ icon, props, cursor, title }) => {

  const classes = useStyles();
  // 定義尺寸表
  const boxSizeInfo = {
    l: 50,
    m: 40,
    s: 30,
    xs: 24,
    xms: 20,
    xxs: 19,
    xxxs: 16,
  }
  const svgSizeInfo = {
    l: '1em',
    m: '0.8em',
    ms: '0.7em',
    s: '0.65em',
  }

  // 利用函式做判斷
  const judgeSize = (target, info) => {
    return info[target] ?? info.l
  }

  const iconSize = {
    width: props.size ? judgeSize(props.size.box, boxSizeInfo) : 50,
    height: props.size ? judgeSize(props.size.box, boxSizeInfo) : 50,
  }

  const svgSize = props.size ? judgeSize(props.size.svg, svgSizeInfo) : '1em';


  return (
    props.mode === 'btn'
      ?
      <IconButton
        className={clsx(classes.iconButton,
          cursor === 'grab' && classes?.cursorGrab,
          props.hoverType ? props.hoverType : ''
        )}
        onClick={props.onClick}
        sx={{
          width: iconSize.width,
          height: iconSize.height
        }}
        title={title ? title : null}
      // color='inherit'
      >
        <SvgIcon
          className={props.classes}
          sx={{ width: svgSize }}
        >
          {icon}
        </SvgIcon>
      </IconButton>
      :
      <Box
        className={classes.iconBox}
        width={iconSize.width}
        height={iconSize.height}
        onClick={props.onClick}
      >
        <SvgIcon
          className={props.classes}
          sx={{
            width: svgSize,
          }}
        >
          {icon}
        </SvgIcon>
      </Box>
  )
}



/** 首頁 home */
function ICON_HOME(props) {
  return <ICON icon={<RiHome3Line />} props={props} title='' />
}

/** 搜尋 */
function ICON_SEARCH(props) {
  return <ICON icon={<RiSearchLine />} props={props} title='' />
}

/** 關閉 close */
function ICON_CLOSE(props) {
  return <ICON icon={<RiCloseFill />} props={props} title='' />
}

/** 垃圾筒 */
function ICON_DELETE_DRAG(props) {
  return <ICON icon={<RiDeleteBin6Line />} props={props} title='' />
}

/** 箭頭 上 arrow up */
function ICON_ARROW_UP(props) {
  return <ICON icon={<RiArrowDropUpLine />} props={props} title='' />
}

/** 箭頭 下 arrow down */
function ICON_ARROW_DOWN(props) {
  return <ICON icon={<RiArrowDropDownLine />} props={props} title='' />
}

/** 箭頭 左 */
function ICON_ARROW_LEFT(props) {
  return <ICON icon={<RiArrowLeftSLine />} props={props} title='' />
}

/** 箭頭 右 */
function ICON_ARROW_RIGHT(props) {
  return <ICON icon={<RiArrowRightSLine />} props={props} title='' />
}

/** 箭頭 單向 */
function ICON_ARROW_ONE_WAY(props) {
  return <ICON icon={<RiArrowRightLine />} props={props} />
}

/** 箭頭 雙向 */
function ICON_ARROW_TWO_WAY(props) {
  return <ICON icon={<RiArrowLeftRightFill />} props={props} />
}

/** dash */
function ICON_DASH(props) {
  return <ICON icon={<RiSubtractFill />} props={props} />
}

/** 地圖圖釘 */
function ICON_MAP_PIN(props) {
  return <ICON icon={<RiMapPinLine />} props={props} title='' />
}

/** 日曆 */
function ICON_CALENDAR(props) {
  return <ICON icon={<RiCalendarTodoLine />} props={props} title='' />
}

/** 收藏 - false */
function ICON_FAVORITE_FALSE(props) {
  return <ICON icon={<RiHeart3Line />} props={props} title='' />
}

/** 收藏 - true */
function ICON_FAVORITE_TRUE(props) {
  return <ICON icon={<RiHeart3Fill />} props={props} title='' />
}

/** 時間天數 */
function ICON_DAY(props) {
  return <ICON icon={<RiTimeLine />} props={props} title='' />
}

/** 導覽語言 */
function ICON_GLOBAL(props) {
  return <ICON icon={<RiGlobalLine />} props={props} title='' />
}

/** 不可取消 */
function ICON_CLOSE_CIRCLE(props) {
  return <ICON icon={<RiCloseCircleLine />} props={props} title='' />
}

/** 可取消 */
function ICON_OK_CIRCLE(props) {
  return <ICON icon={<RiCheckboxCircleLine />} props={props} title='' />
}

/** 出示票證 */
function ICON_PHONE(props) {
  return <ICON icon={<RiSmartphoneLine />} props={props} title='' />
}

/** 注意 */
function ICON_NOTICE(props) {
  return <ICON icon={<RiErrorWarningLine />} props={props} title='' />
}

/** 重選 */
function ICON_RESTART(props) {
  return <ICON icon={<RiRestartLine />} props={props} title='' />
}

/** 加 */
function ICON_ADD(props) {
  return <ICON icon={<RiAddCircleFill />} props={props} title='' />
}

/** 加 - 線條 */
function ICON_ADD_LINE(props) {
  return <ICON icon={<RiAddCircleLine />} props={props} title='' />
}

/** 減 */
function ICON_DEL(props) {
  return <ICON icon={<RiIndeterminateCircleFill />} props={props} title='' />
}

/** 減 - 線條 */
function ICON_DEL_LINE(props) {
  return <ICON icon={<RiIndeterminateCircleLine />} props={props} title='' />
}

/** Logo Google */
function ICON_LOGO_GOOGLE(props) {
  return <ICON icon={<FcGoogle />} props={props} title='' />
}

/** Logo LINE */
function ICON_LOGO_LINE(props) {
  return <ICON icon={<FaLine />} props={props} title='' />
}

/** 密碼 顯示 */
function ICON_PASSWORD_SHOW(props) {
  return <ICON icon={<AiOutlineEye />} props={props} />
}

/** 密碼 隱藏 */
function ICON_PASSWORD_HIDE(props) {
  return <ICON icon={<AiOutlineEyeInvisible />} props={props} />
}

/** 篩選 */
function ICON_OPTIONS(props) {
  return <ICON icon={<RiEqualizerLine />} props={props} />
}

/** 會員 */
function ICON_ACCOUNT(props) {
  return <ICON icon={<VscAccount />} props={props} />
}

/** 選單 */
function ICON_MENU(props) {
  return <ICON icon={<RiMenu2Line />} props={props} />
}

/** 分享 */
function ICON_SHARE(props) {
  return <ICON icon={<IoShareSocialOutline />} props={props} />
}

/** 信用卡 */
function ICON_CREDIT_CARD(props) {
  return <ICON icon={<BsCreditCard />} props={props} />
}

/** toTop */
function ICON_TO_TOP(props) {
  return <ICON icon={<BiArrowToTop />} props={props} />
}

/** 選取 圓型 - 選取 */
function ICON_CHECKBOX_CIRCLE_TRUE(props) {
  return <ICON icon={<RiCheckboxCircleFill />} props={props} />
}

/** 選取 圓型 - 未選 */
function ICON_CHECKBOX_CIRCLE_FALSE(props) {
  return <ICON icon={<RiCheckboxBlankCircleLine />} props={props} />
}

/** 餐食 */
function ICON_MEALS(props) {
  return <ICON icon={<RiRestaurantLine />} props={props} />
}

/** 飯店 */
function ICON_HOTEL(props) {
  return <ICON icon={<RiHotelBedLine />} props={props} />
}

/** 複製 */
function ICON_COPY(props) {
  return <ICON icon={<TbCopy />} props={props} />
}

/** 下載 */
function ICON_FILESERVER_DOWNLOAD(props) {
  return <ICON icon={<RiDownload2Line />} props={props} />
}


/** tag - 行前說明 */
function ICON_TRAVE_INFO(props) {
  return <ICON icon={<RiFlag2Line />} props={props} />
}

/** tag - 航班住宿 */
function ICON_FLIGHT_HOTEL(props) {
  return <ICON icon={<RiFlightTakeoffLine />} props={props} />
}

/** tag - 行程規劃 */
function ICON_SCHEDULE(props) {
  return <ICON icon={<RiMap2Line />} props={props} />
}

/** tag - 旅遊資訊 */
function ICON_INFORMATION(props) {
  return <ICON icon={<RiAlarmWarningLine />} props={props} />
}

/** 選擇客製服務 - AI生成行程 */
function ICON_AI_CREATE(props) {
  return <ICON icon={<RiSparkling2Line />} props={props} />
}

/** 選擇客製服務 - 調整行程 */
function ICON_SUITCASE(props) {
  return <ICON icon={<RiSuitcase2Line />} props={props} />
}

/** 選擇客製服務 - 填寫需求表單 */
function ICON_EDIT_FORM(props) {
  return <ICON icon={<RiFileEditLine />} props={props} />
}

/** 送出成功 - 訂單完成 */
function ICON_SUCCESS(props) {
  return <ICON icon={<RiThumbUpLine />} props={props} />
}

/** 收合箭頭 上 arrow up */
function ICON_SLINE_ARROW_UP(props) {
  return <ICON icon={<RiArrowDownSLine />} props={props} />
}

/** 收合箭頭 下 arrow down */
function ICON_SLINE_ARROW_DOWN(props) {
  return <ICON icon={<RiArrowUpSLine />} props={props} />
}

/** 連結 */
function ICON_LINK(props) {
  return <ICON icon={<RiExternalLinkLine />} props={props} />
}

/** 編輯 - 有底線 */
function ICON_EDIT_LINE(props) {
  return <ICON icon={<RiEditLine />} props={props} />
}

/** 行程節奏 - 緊湊充實 */
function ICON_FLASHLIGHT(props) {
  return <ICON icon={<RiFlashlightLine />} props={props} />
}

/** 行程節奏 - 適中 */
function ICON_FOOTPRINT(props) {
  return <ICON icon={<RiFootprintLine />} props={props} />
}

/** 行程節奏 - 悠閒緩慢 */
function ICON_ARMCHAIR(props) {
  return <ICON icon={<RiArmchairLine />} props={props} />
}

/** 行程調整 - 拖曳按鈕 */
function ICON_DRAGGABLE(props) {
  return <ICON icon={<RiDraggable />} props={props} />
}

/** 行程調整 - 新增行程 */
function ICON_ADD_FILL(props) {
  return <ICON icon={<RiAddFill />} props={props} />
}

/** 行程調整 - 刪除行程 */
function ICON_CLOSE_LINE(props) {
  return <ICON icon={<RiCloseLine />} props={props} />
}

/** 行程調整 - 恢復預設 */
function ICON_RESET_LEFT_LINE(props) {
  return <ICON icon={<RiResetLeftLine />} props={props} />
}

/** 行程調整 - 景點已滿 */
function ICON_CHECK_LINE(props) {
  return <ICON icon={<RiCheckLine />} props={props} />
}

/** 行程調整 - 功能說明 */
function ICON_INFORMATION_LINE(props) {
  return <ICON icon={<RiInformationLine />} props={props} />
}

/** 關閉 close 填色 */
function ICON_CLOSE_RADIUS(props) {
  return <ICON icon={<RiCloseCircleFill size="100%" />} props={props} />
}